export enum SeatingEmailType {
    Confirmation = 'Confirmation',
    Cancellation = 'Cancellation',
    ShareConfirmation = 'ShareConfirmation',
}

export enum SeatingOccasions {
    None = '0',
    Birthday = '1',
    Anniversary = '2',
    Graduation = '3',
    Other = '4',
}

export namespace SeatingOccasions {
    export const Label = (occasion: string): string => {
        switch (occasion) {
            case SeatingOccasions.None:
                return 'None';
            case SeatingOccasions.Birthday:
                return 'Birthday';
            case SeatingOccasions.Anniversary:
                return 'Anniversary';
            case SeatingOccasions.Graduation:
                return 'Graduation';
            default:
                return 'Other';
        }
    };
}

export class SeatingData {
    LocationId: string;
    LocationName: string;
    LocationPhoneNumber: string;

    Guests: number;
    TimeSlot: string;
    Day: string;

    FirstName: string;
    LastName: string;
    PhoneNumber: string;
    Email: string;
    Occasion: string;
    SpecialOccasion: string;
    ReceivePromotions: boolean;

    PartyKey: string;

    ShareEmails: string;
    ShareMessage: string;

    WaitTime: string;
    IsWaitlist?: boolean;

    constructor(init?: Partial<SeatingData>) {
        Object.assign(this, init);
    }

    public set Datetime(_: any) {
        // No-op: setter required for Object.assign compatibility
    }

    public get Datetime(): Date {
        if (!this.TimeSlot) return new Date();
        return new Date(`${this.Day}T${this.TimeSlot}`);
    }

    public GetContract() {
        const contract: any = {
            unitId: Number(this.LocationId),
            firstName: this.FirstName,
            lastName: this.LastName,
            mobileNumber: this.PhoneNumber,
            email: this.Email,
            partySize: this.Guests,
            receivePromotions: this.ReceivePromotions,
            reservationDate: `${this.Day}T${this.TimeSlot}.000Z`,
            occasion: this.Occasion,
            specialOccasion: this.SpecialOccasion,
        };

        if (this.PartyKey) {
            contract.partyKey = this.PartyKey;
        }

        if (this.ShareEmails) {
            contract.shareEmails = this.ShareEmails;

            if (this.ShareMessage) {
                contract.shareMessage = this.ShareMessage;
            }
        }

        return contract;
    }

    public static ParseTimeSlot(value: string): Date {
        const date = new Date();
        if (!value.includes(':')) {
            return date;
        }

        const [hours, minutes, seconds] = value.split(':');
        date.setHours(Number(hours));
        date.setMinutes(Number(minutes));
        date.setSeconds(Number(seconds));

        return date;
    }

    public static TimeSlotToDatetimeString(timeSlot: string): string {
        const date = new Date();
        const [hours, minutes, seconds] = timeSlot.split(':');
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
            2,
            '0'
        )}T${hours}:${minutes}:${seconds}.000Z`;
    }

    public static Today(): string {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
}
